<template>
  <card header-classes="bg-transparent">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Objetos por serviço</h6>
      </div>
      <div class="col">
        <el-select
          v-model="month"
          placeholder="Selecione  uma opção"
          @change="initBigChart()"
        >
          <el-option
            v-for="row of options"
            :key="row.key"
            :label="row.label"
            :value="row.key"
          ></el-option>
        </el-select>
      </div>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      :default-sort="{ prop: 'name', order: 'ascending' }"
    >
      <el-table-column
        sortable
        prop="status"
        :label="$t('servico')"
      ></el-table-column>
      <el-table-column
        sortable
        prop="quantity"
        :label="$t('quantidade')"
      ></el-table-column>
      <el-table-column label="%" width="180">
        <template slot-scope="scope">
          <el-progress
            :text-inside="true"
            :stroke-width="26"
            :percentage="scope.row.percentage"
          ></el-progress>
        </template>
      </el-table-column>
    </el-table>
  </card>
</template>
<script>
import { PrepostCountService } from "@/services/customers/prepost.count.services";
import moment from "moment";
import "moment/locale/pt-br";
export default {
  name: " ",
  data() {
    return {
      month: "",
      options: [],
      loading: false,
      tableData: [],
    };
  },
  components: {},
  methods: {
    initBigChart() {
      const vm = this;
      vm.loading = true;
      PrepostCountService.services(vm.month)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    const vm = this;
    moment.locale("pt-br");
    const today = moment();
    vm.month = today.format("YYYY-MM");
    for (let i = 0; i < 6; i++) {
      vm.options.push({
        key: today.format("YYYY-MM"),
        label: `${today.format("MMM").toUpperCase()}/${today.format("YYYY")}`,
      });
      today.subtract(1, "month");
    }
    vm.initBigChart(0);
  },
};
</script>
